import { render, staticRenderFns } from "./LessonRating.vue?vue&type=template&id=a063c0c0&scoped=true"
import script from "./LessonRating.vue?vue&type=script&lang=js"
export * from "./LessonRating.vue?vue&type=script&lang=js"
import style0 from "./LessonRating.vue?vue&type=style&index=0&id=a063c0c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a063c0c0",
  null
  
)

export default component.exports